
import { defineComponent } from "vue";
import { Form, Field } from "vee-validate";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
//import Swal from "sweetalert2/dist/sweetalert2.min.js";
// import * as Yup from "yup";
import ApiService from "@/core/services/ApiService";

export default defineComponent({
  name: "new-entity-course",
  components: {
    Form,
    Field,
    Datatable,
  },
  data() {
    return {
      batch: {},
      employee: {},
      details: {},
      weekplan: {},
      entityTypes: [],
      industry: [],
      entityInfos: [],
      divisions: [],
      districts: [],
      subDistricts: [],
      empDistricts: [],
      tableHeader: [
        {
          name: "Sl",
          key: "sl",
          sortable: true,
          width: "5px",
        },
        {
          name: "Training Partner	",
          key: "logo",
          sortable: true,
        },
        {
          name: "Claim",
          key: "short_name",
          sortable: true,
        },
        {
          name: "Adjustment Percentage	",
          key: "name",
          sortable: true,
        },
        {
          name: "Tranche",
          key: "phone",
          sortable: true,
        },
        {
          name: "Advanced Amount	",
          key: "email",
          sortable: true,
        },
        {
          name: "Current Balance",
          key: "email",
          sortable: true,
        },
        {
          name: "Payment Date",
          key: "email",
          sortable: true,
        },
        {
          name: "Payment Instruction Type	",
          key: "email",
          sortable: true,
        },
        {
          name: "Payment Instruction Description",
          key: "email",
          sortable: true,
        },
        {
          name: "Finman Code",
          key: "email",
          sortable: true,
        },
        {
          name: "Contract Signing Date",
          key: "email",
          sortable: true,
        },
        {
          name: "Contract Amount",
          key: "email",
          sortable: true,
        },
        {
          name: "Payment Adjustment Amount",
          key: "email",
          sortable: true,
        },
        {
          name: "Created",
          key: "email",
          sortable: true,
        },
        {
          name: "Modified",
          key: "modified",
          sortable: false,
          width: "150px",
        },
      ],
      tableData: [],
      loading: false,
      courseInfoData: false,
      showCourseNotice: false,
      showtrainingProviderNotice: false,
    };
  },
  async created() {
    await this.getEntityTypes();
    await this.getEntityInfos();
  },
  methods: {
    async formSubmit() {
      //form submit
    },
    async getEntityInfos() {
      await ApiService.get("entity/infos")
        .then((response) => {
          this.entityInfos = response.data;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    async getEntityTypes() {
      await ApiService.get("entity/types")
        .then((response) => {
          this.entityTypes = response.data;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    courseInfo() {
      this.courseInfoData = true;
    },
    courseNotice() {
      this.showCourseNotice = true;
    },
    trainingProviderNotice() {
      this.showtrainingProviderNotice = true;
    },
  },
  setup() {
    const AssociationSchema = [];
    return {
      AssociationSchema,
    };
  },
});
